import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGetAllLeagues } from '../../components/header/types/header';


type SelectedLeagueState = {
  id: string | null;
  name: string | null;
  league: IGetAllLeagues | null;
};

const initialState: SelectedLeagueState = {
  id: null,
  name: null,
  league: null,
};

const selectedLeagueSlice = createSlice({
  name: 'selectedLeague',
  initialState,
  reducers: {
    setSelectedLeague(state, action: PayloadAction<IGetAllLeagues>) {
      const l = action.payload;
      state.id = l.leagueId ?? null;
      state.name = l.leagueName ?? null;
      state.league = l;
    },
    clearSelectedLeague(state) {
      state.id = null;
      state.name = null;
      state.league = null;
    },
  },
});

export const { setSelectedLeague, clearSelectedLeague } = selectedLeagueSlice.actions;

// selectors
export const selectSelectedLeagueId = (s: any) => s?.selectedLeague?.id as string | null;
export const selectSelectedLeagueName = (s: any) => s?.selectedLeague?.name as string | null;
export const selectSelectedLeague = (s: any) => s?.selectedLeague?.league as IGetAllLeagues | null;

export default selectedLeagueSlice.reducer;
